import React from "react"
import MetaTags from "react-meta-tags"
import Strings from "../util/Strings"


const MetaTitle = ({title}) =>  <MetaTags>
                <title>{title} | {Strings.APP_DESCRIPTION}</title>
            </MetaTags>

export default MetaTitle